import { render, staticRenderFns } from "./ImportTransferStock.vue?vue&type=template&id=58cd58e0&"
import script from "./ImportTransferStock.vue?vue&type=script&lang=js&"
export * from "./ImportTransferStock.vue?vue&type=script&lang=js&"
import style0 from "./ImportTransferStock.vue?vue&type=style&index=0&id=58cd58e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports